import { render, staticRenderFns } from "./Headerbar.vue?vue&type=template&id=65301979&"
import script from "./Headerbar.vue?vue&type=script&lang=js&"
export * from "./Headerbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports